import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist({
  key: "Yvooa-Core",
  storage: sessionStorage,
});

export const listingStore = atom({
  key: "listingStore",
  default: {
    listings: {},
    prospects: {},
    selMenu: "",
  },
  effects_UNSTABLE: [persistAtom],
});
